module.exports = __webpack_public_path__ + "img/63da4dd.png";